"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toId = toId;
exports.default = toIds;

function toId(obj) {
  if (obj instanceof Object) {
    return obj.id;
  }

  return obj;
}

function toIds(obj) {
  if (!obj) {
    return [];
  }

  if (Array.isArray(obj) || obj.map instanceof Function) {
    return obj.map(toId);
  }

  return [toId(obj)];
}